import { render, staticRenderFns } from "./NewQCStep2.vue?vue&type=template&id=6b9625ce&scoped=true&"
import script from "./NewQCStep2.vue?vue&type=script&lang=js&"
export * from "./NewQCStep2.vue?vue&type=script&lang=js&"
import style0 from "./NewQCStep2.vue?vue&type=style&index=0&id=6b9625ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9625ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCombobox } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCombobox,
  VForm,
  VSelect,
})
